var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"sidebar",staticClass:"sidebar scrollbar-default",class:{
    'sidebar--active': _vm.isShowing,
    'sidebar--progress': _vm.isProgressPage,
  },style:({
    '--sidebar-top-position': (_vm.sidebarTopPosition + "px"),
  })},[(_vm.isClientPage)?_c('main-sidebar-client-links',{on:{"hideSidebar":function($event){return _vm.$emit('hideSidebar')}}}):_c('main-sidebar-games',{on:{"hideSidebar":function($event){return _vm.$emit('hideSidebar')}}}),(_vm.isMobile)?_c('main-sidebar-footer',{on:{"hideSidebar":function($event){return _vm.$emit('hideSidebar')}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }